let QRP = {
  PRODUCTS: {
    AUTO: 1,
    HOME: 21,
    CONDO: 18,
    RENTERS: 12,
    HA_BUNDLE: '1_21',
    CA_BUNDLE: '1_18',
    RA_BUNDLE: '1_12',
  },
};

export default QRP;



//////////////////
// WEBPACK FOOTER
// ./config/QRP.env.js
// module id = null
// module chunks = 